import { gql } from 'urql';

const gqlQuery = gql`
  query v2vOptions {
    v2vOptions {
      __typename
      ... on V2VOptionsEnabled {
        isFirstTime
        maxTransfer {
          amount
          formatted
        }
        educationalScreenV2 {
          body {
            ... on BulletComponent {
              id
              items
              __typename
            }
            ... on TextComponent {
              copy
              id
              __typename
            }
          }
          header {
            __typename
            ... on ImageHeaderComponentV2 {
              id
              image {
                id
                fallbackURL
                illustrationKey
              }
            }
            ... on AnimationHeaderComponentV2 {
              id
              animation {
                key
              }
              backgroundTexture
            }
          }
          footer {
            ... on ButtonComponentV2 {
              buttonText
              buttonStyle
            }
          }
          disclaimer
        }
      }
      ... on V2VOptionsDisabled {
        title
        message
      }
      ... on V2VOptionsBlocked {
        title
        message
      }
      ... on V2VOptionsLimitReached {
        title
        message
      }
      ... on V2VOptionsActivateCard {
        title
        message
        card {
          id
        }
      }
    }
  }
`;

export default gqlQuery;
